import { createUseStyles } from 'react-jss'

export default createUseStyles({
  controlsPanel: {
    textAlign: 'center',
    marginBottom: 40
  }
})
